import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["placeholder", "required", "readonly"]
const _hoisted_4 = ["placeholder", "required", "readonly"]
const _hoisted_5 = ["placeholder", "required", "min", "max", "step", "readonly"]
const _hoisted_6 = ["placeholder", "required", "min", "max", "readonly"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 5,
  class: "scrollListContainer"
}
const _hoisted_11 = ["disabled", "value"]
const _hoisted_12 = {
  key: 6,
  class: "flex_align_centered flex-wrap"
}
const _hoisted_13 = ["name"]
const _hoisted_14 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      tabindex: "0",
      "aria-label": _ctx.$localizationServices.GetLocalizedValue(_ctx.config.label, _ctx.config.label)
    }, _toDisplayString(_ctx.$localizationServices.GetLocalizedValue(_ctx.config.label, _ctx.config.label)), 9, _hoisted_2),
    (_ctx.config.type == _ctx.model.FieldType.Text && (<OM.TextField>_ctx.config).isTextArea)
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 0,
          class: "form-control",
          rows: "3",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalModel) = $event)),
          placeholder: _ctx.$localizationServices.GetLocalizedValue(_ctx.config.placeholder,_ctx.config.placeholder),
          required: _ctx.config.isRequired,
          readonly: _ctx.readonly
        }, null, 8, _hoisted_3)), [
          [_vModelText, _ctx.internalModel]
        ])
      : (_ctx.config.type == _ctx.model.FieldType.Text)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalModel) = $event)),
            placeholder: _ctx.$localizationServices.GetLocalizedValue(_ctx.config.placeholder,_ctx.config.placeholder),
            required: _ctx.config.isRequired,
            readonly: _ctx.readonly
          }, null, 8, _hoisted_4)), [
            [_vModelText, _ctx.internalModel]
          ])
        : (_ctx.config.type == _ctx.model.FieldType.Number)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 2,
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalModel) = $event)),
              placeholder: _ctx.$localizationServices.GetLocalizedValue(_ctx.config.placeholder,_ctx.config.placeholder),
              required: _ctx.config.isRequired,
              min: (<OM.NumberField>_ctx.config).min,
              max: (<OM.NumberField>_ctx.config).max,
              step: (<OM.NumberField>_ctx.config).step,
              readonly: _ctx.readonly
            }, null, 8, _hoisted_5)), [
              [_vModelText, _ctx.internalModel]
            ])
          : (_ctx.config.type == _ctx.model.FieldType.Date)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 3,
                type: "date",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.internalModel) = $event)),
                placeholder: _ctx.$localizationServices.GetLocalizedValue(_ctx.config.placeholder,_ctx.config.placeholder),
                required: _ctx.config.isRequired,
                min: (<OM.DateField>_ctx.config).min,
                max: (<OM.DateField>_ctx.config).max,
                readonly: _ctx.readonly
              }, null, 8, _hoisted_6)), [
                [_vModelText, _ctx.internalModel]
              ])
            : (_ctx.config.type == _ctx.model.FieldType.Select)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 4,
                  disabled: _ctx.readonly,
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.internalModel) = $event))
                }, [
                  _createElementVNode("option", _hoisted_8, [
                    _createVNode(_component_localized_text, {
                      localizedKey: (<OM.SelectField>_ctx.config).placeholder,
                      text: (<OM.SelectField>_ctx.config).placeholder
                    }, null, 8, ["localizedKey", "text"])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((<OM.SelectField>_ctx.config).options, (item, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: item.value
                    }, _toDisplayString(_ctx.$localizationServices.GetLocalizedValue(item.text, item.text)), 9, _hoisted_9))
                  }), 128))
                ], 8, _hoisted_7)), [
                  [_vModelSelect, _ctx.internalModel]
                ])
              : (_ctx.config.type == _ctx.model.FieldType.Checkbox)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((<OM.CheckboxField>_ctx.config).options, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "scrollListItem",
                        key: i
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          disabled: _ctx.readonly,
                          class: "form-check",
                          value: item.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.internalModel) = $event))
                        }, null, 8, _hoisted_11), [
                          [_vModelCheckbox, this.internalModel]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$localizationServices.GetLocalizedValue(item.text, item.text)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_ctx.config.type == _ctx.model.FieldType.RadioButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((<OM.RadioButtonField>_ctx.config).options, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "d-flex align-items-center",
                          name: _ctx.config.identifier.toString(),
                          key: option.value
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "me-2 w-auto",
                            type: "radio",
                            value: option.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.internalModel) = $event)),
                            disabled: _ctx.readonly
                          }, null, 8, _hoisted_14), [
                            [_vModelRadio, _ctx.internalModel]
                          ]),
                          _createVNode(_component_localized_text, {
                            localizedKey: option.text,
                            text: option.text
                          }, null, 8, ["localizedKey", "text"])
                        ], 8, _hoisted_13))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [], 64))
  ]))
}